import { Component, inject, Input, OnInit } from '@angular/core'
import Performer from '@account/Performer'
import OrderItem from '@account/OrderItem'
import {
	SelectComponent,
	SelectItem,
	SelectValue,
} from '@ui/Components/Form/Select/Select.Component'
import Pagination from '@ui/Pagination'
import HttpError from '@ui/HttpError'
import { OrderItemService } from '@account/Services/OrderItemService'
import { CardComponent } from '@ui/Components/Card/Card.Component'
import { CardContentComponent } from '@ui/Components/Card/CardContent.Component'
import { EntriesTableComponent } from '@account/Components/Entries/Table/EntriesTable.Component'

@Component({
	selector: 'performer-entries-component',
	templateUrl: './PerformerEntries.Component.html',
	imports: [
		CardComponent,
		CardContentComponent,
		SelectComponent,
		EntriesTableComponent,
	],
})
export class PerformerEntriesComponent implements OnInit {
	@Input() public performer: Performer

	public orderItems: OrderItem[] = []

	public years: SelectItem[] = [
		{
			label: 'Reset',
			value: undefined,
		},
	]

	public starts: number

	public readonly orderItemService: OrderItemService

	constructor() {
		this.orderItemService = inject(OrderItemService)

		this.orderItemService.clearLocalStorageKey().resetFilter()

		if (
			this.orderItemService.filterable.performance_class &&
			this.orderItemService.filterable.performance_class.starts
		) {
			this.starts = parseInt(
				this.orderItemService.filterable.performance_class.starts,
				10,
			)
		}
	}

	public ngOnInit() {
		const date = new Date()

		for (
			let year = date.getFullYear() - 5;
			year <= date.getFullYear() + 1;
			year++
		) {
			this.years.push({
				value: year,
				label: year.toString(),
			})
		}

		this.orderItemService.filterable.performers[0].id = this.performer.id

		this.getOrderItems()
	}

	public chooseYear = async (year: SelectValue) => {
		this.starts = typeof year === 'number' ? year : undefined

		this.orderItemService.filterable.performance_class.starts = year as string

		await this.getOrderItems()
	}

	public setOrderItemPaginator = async (
		paginator: Pagination,
	): Promise<void> => {
		this.orderItemService.setPaginator(paginator)

		await this.getOrderItems(false)
	}

	public filterCancelledEntries = async (cancelled: boolean): Promise<void> => {
		this.orderItemService.filterable.cancelled = cancelled

		await this.getOrderItems()
	}

	private readonly getOrderItems = async (resetPaginator = true) => {
		try {
			if (resetPaginator) {
				this.orderItemService.paginatorInit(true)
			}

			this.orderItems = await this.orderItemService.filter()
		} catch (error) {
			if (!(error instanceof HttpError)) {
				throw error
			}
		}
	}
}
